// состояния и классы "двойного" селекта
export const DOUBLE_SELECT_STATUSES = {
  init: 0,
  open: 1,
  success: 2,
}
export const DOUBLE_SELECT_CLASSES = ['', 'open', 'success']
